import {useNavigate} from "react-router-dom";
import { saveRequestFields } from "../../../../services/api";
export default function useFormSubmit(exemptionType,requestId){
    const navigate = useNavigate();

    return function(data){
        console.log('SAVING Request fields',data);
        saveRequestFields(
            requestId,
            data,
            // I always go to upload from here, so no need to next-step calculate
            ()=>navigate(`/request/wizard/step3documentupload/${exemptionType}/${requestId}`),
            r=>console.error('API error',r)
        );
    }
}
